import * as React from "react"
import type { SVGProps } from "react"
const SvgPhone = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M19.95 21.29a15 15 0 0 1-6.17-1.37q-3.06-1.36-5.56-3.86a19 19 0 0 1-3.86-5.55A15 15 0 0 1 3 4.34a1 1 0 0 1 1.05-1.05H8.1a1 1 0 0 1 .63.23 1 1 0 0 1 .32.57l.65 3.5q.05.4-.02.67-.09.27-.28.48l-2.43 2.45q.5.91 1.2 1.78.67.87 1.5 1.67a18 18 0 0 0 3.43 2.65l2.35-2.35a1.4 1.4 0 0 1 .59-.34 2 2 0 0 1 .71-.06l3.45.7q.35.09.57.36a1 1 0 0 1 .23.59v4.05a1 1 0 0 1-1.05 1.05m-13.92-12 1.64-1.65-.42-2.35H5.03q.12 1.02.35 2.02a11 11 0 0 0 .65 1.98m8.94 8.95a12 12 0 0 0 4.03 1v-2.2l-2.35-.48z" />
  </svg>
)
export default SvgPhone
